import { render, staticRenderFns } from "./FormGroup.vue?vue&type=template&id=6ed8dc27&scoped=true&"
import script from "./FormGroup.vue?vue&type=script&lang=ts&"
export * from "./FormGroup.vue?vue&type=script&lang=ts&"
import style0 from "./FormGroup.vue?vue&type=style&index=0&id=6ed8dc27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed8dc27",
  null
  
)

export default component.exports